import { type FileRoutesByTo } from '@/routeTree.gen';
export type TRoutes = keyof FileRoutesByTo;
export const PAGE_SLUG = {
  HOME: 'home',
  NBN: 'nbn',
  ABOUT_SPEEDS: 'about-speeds',
  REFER_A_FRIEND: 'refer-a-friend',
  WARP_SPEED: 'warp-speed',
  HIBERNATE: 'hibernate',
  FTTP: 'fttp',
  HFC: 'hfc',
  MOBILEPHONE: 'mobilephone',
  COVERAGE: 'coverage',
  ABOUT_US: 'about-us',
  CONTACT_US: 'contact-us',
  ASSISTANCE: 'assistance',
  ESAFETY: 'esafety',
  LODGE_A_COMPLAINT: 'lodge-a-complaint',
  NETWORK_OUTAGE: 'network-outage',
  DEMO_PAGE: 'demo-page-v2',
  APP: 'app',
  TERMS: 'terms',
  PRIVACY_POLICY: 'privacy-policy',
  DOWNLOAD: 'download',
  EXRAY: 'exray',
  SPEED_TEST: 'speed-test',
  GET_EXETEL_APP: 'get-exetel-app',
  DISASTER_RELIEF: 'disaster-relief',
  SPECIALIST_SUPPORT: 'specialist-support',
  EMAIL: 'email',
};

export type PageSlugType = (typeof PAGE_SLUG)[keyof typeof PAGE_SLUG];

type CMSRoutes = Exclude<TRoutes, '/blog' | '/blog/$slug'>;

export const PAGE_KEY: Record<CMSRoutes, PageSlugType> = {
  '/': PAGE_SLUG.HOME,
  '/broadband/nbn': PAGE_SLUG.NBN,
  '/broadband/about-speeds': PAGE_SLUG.ABOUT_SPEEDS,
  '/broadband/refer-a-friend': PAGE_SLUG.REFER_A_FRIEND,
  '/broadband/warp-speed': PAGE_SLUG.WARP_SPEED,
  '/broadband/hibernate': PAGE_SLUG.HIBERNATE,
  '/broadband/fttp': PAGE_SLUG.FTTP,
  '/broadband/hfc': PAGE_SLUG.HFC,
  '/mobilephone': PAGE_SLUG.MOBILEPHONE,
  '/mobilephone/coverage': PAGE_SLUG.COVERAGE,
  '/about-us': PAGE_SLUG.ABOUT_US,
  '/contact-us': PAGE_SLUG.CONTACT_US,
  '/assistance': PAGE_SLUG.ASSISTANCE,
  '/esafety': PAGE_SLUG.ESAFETY,
  '/lodge-a-complaint': PAGE_SLUG.LODGE_A_COMPLAINT,
  '/network-outage': PAGE_SLUG.NETWORK_OUTAGE,
  '/demo-page': PAGE_SLUG.DEMO_PAGE,
  '/app': PAGE_SLUG.APP,
  '/terms': PAGE_SLUG.TERMS,
  '/privacy-policy': PAGE_SLUG.PRIVACY_POLICY,
  '/app/download': PAGE_SLUG.DOWNLOAD,
  '/exray': PAGE_SLUG.EXRAY,
  '/speed-test': PAGE_SLUG.SPEED_TEST,
  '/get-exetel-app': PAGE_SLUG.GET_EXETEL_APP,
  '/disaster-relief': PAGE_SLUG.DISASTER_RELIEF,
  '/specialist-support': PAGE_SLUG.SPECIALIST_SUPPORT,
  '/email': PAGE_SLUG.EMAIL,
};

export type SEORecursiveMapping = {
  slug: PageSlugType | null;
  next: null | SEORecursiveMapping;
  isIndexed?: false;
};

export type SEOMappingType = {
  [key in CMSRoutes]: SEORecursiveMapping;
};

//NOTE: in case we will add new routes, modify this as well. for SEO
export const SEO_MAPPING: SEOMappingType = {
  '/': {
    slug: null,
    next: null,
  },
  '/broadband/nbn': {
    slug: PAGE_SLUG.HOME,
    next: null,
  },
  '/broadband/about-speeds': {
    slug: PAGE_SLUG.HOME,
    next: null,
  },
  '/broadband/refer-a-friend': {
    slug: PAGE_SLUG.HOME,
    next: null,
  },
  '/broadband/warp-speed': {
    slug: PAGE_SLUG.HOME,
    next: null,
  },
  '/broadband/hibernate': {
    slug: PAGE_SLUG.HOME,
    next: null,
  },
  '/broadband/fttp': {
    slug: PAGE_SLUG.HOME,
    next: null,
  },
  '/broadband/hfc': {
    slug: PAGE_SLUG.HOME,
    next: null,
  },
  '/mobilephone': {
    slug: PAGE_SLUG.HOME,
    next: null,
  },
  '/mobilephone/coverage': {
    slug: PAGE_SLUG.MOBILEPHONE,
    next: {
      slug: PAGE_SLUG.HOME,
      next: null,
    },
  },
  '/about-us': {
    slug: PAGE_SLUG.HOME,
    next: null,
  },
  '/contact-us': {
    slug: PAGE_SLUG.HOME,
    next: null,
  },
  '/assistance': {
    slug: PAGE_SLUG.HOME,
    next: null,
  },
  '/esafety': {
    slug: PAGE_SLUG.HOME,
    next: null,
  },
  '/lodge-a-complaint': {
    slug: PAGE_SLUG.HOME,
    next: null,
  },
  '/network-outage': {
    slug: PAGE_SLUG.HOME,
    next: null,
  },
  '/demo-page': {
    slug: PAGE_SLUG.HOME,
    next: null,
  },
  '/app': {
    slug: PAGE_SLUG.HOME,
    next: null,
  },
  '/terms': {
    slug: PAGE_SLUG.HOME,
    next: null,
  },
  '/privacy-policy': {
    slug: PAGE_SLUG.HOME,
    next: null,
  },
  '/app/download': {
    slug: PAGE_SLUG.APP,
    next: {
      slug: PAGE_SLUG.HOME,
      next: null,
    },
  },
  '/exray': {
    slug: PAGE_SLUG.HOME,
    next: null,
  },
  '/speed-test': {
    slug: PAGE_SLUG.HOME,
    next: null,
  },
  '/get-exetel-app': {
    slug: PAGE_SLUG.HOME,
    next: null,
  },
  '/disaster-relief': {
    slug: PAGE_SLUG.HOME,
    next: null,
  },
  '/specialist-support': {
    slug: PAGE_SLUG.HOME,
    next: null,
  },
  '/email': {
    slug: PAGE_SLUG.HOME,
    next: null,
    isIndexed: false,
  },
} as const;

export type PageKeyType = keyof typeof PAGE_KEY;
